import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './constants/routes';
import store from './store';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const { isAuthorized, mfaIsRequired } = store.getters;
  const loadingApp = store.getters.showSiteLoader;

  const anonymousAccessPages = routes.filter(r => r.allowAnonymous).map(r => r.name);

  if (!loadingApp && !isAuthorized && anonymousAccessPages.indexOf(to.name) === -1) {
    store.dispatch('clearUser');
    router.replace('/login');
    return;
  }

  // Block user from going past main account page without setting up MFA
  if (mfaIsRequired && anonymousAccessPages.indexOf(to.name) === -1 && to.name !== 'account') {
    store.commit('setGlobalAlert', {
      msg: 'You must configure MFA before continuing to use KGB Aviation Solutions Portal.',
      error: true,
    });
    router.replace('/account');

    return;
  }

  if (to.matched.length) {
    if (to.meta.title) {
      document.title = `KGB Aviation | ${to.meta.title}`;
    } else {
      document.title = 'KGB Aviation';
    }

    next();
  }
});

export default router;
